import { motion } from "framer-motion";
import { useState } from "react";
import { EASING } from "../../utils/easingUtils";
import polygon1 from "../../images/polygone/polygon-4.png";
import polygon2 from "../../images/polygone/polygon-5.png";
import polygon3 from "../../images/polygone/polygon-6.png";
import polygon4 from "../../images/polygone/polygon-7.png";
import polygon5 from "../../images/polygone/polygon-8.png";
import polygon6 from "../../images/polygone/polygon-9.png";
import polygon7 from "../../images/polygone/polygon-10.png";
import polygon8 from "../../images/polygone/polygon-11.png";

import polygon9 from "../../images/polygone/polygon-12.png";
import polygon10 from "../../images/polygone/polygon-13.png";
import polygon11 from "../../images/polygone/polygon-14.png";
import polygon12 from "../../images/polygone/polygon-15.png";
import polygon13 from "../../images/polygone/polygon-16.png";
import polygon14 from "../../images/polygone/polygon-17.png";
import polygon15 from "../../images/polygone/polygon-18.png";
import polygon16 from "../../images/polygone/polygon-19.png";
import useIsMobile from "hooks/isMobile";

interface Header2Props {
  title: string;
  url: string;
}

function Header2({ title, url }: Header2Props) {
  const [isHovering, setIsHovering] = useState(false);
  const [isButtonHovering, setIsButtonHovering] = useState(false);

  const isMobile = useIsMobile();
  return (
    <div className="">
      {/* desktop version */}
      {!isMobile && (
        <div className="relative flex-col items-center justify-center hidden w-full h-[600px] lg:flex">
          <div className="mt-52">
            <h3 className="text-[#4663AC] text-4xl font-semibold  ">Rejoignez Event to Bee</h3>
            <p className="text-[#6C6C6C] text-xl mt-3  ">{title}</p>
            <div className="flex justify-center">
              <button
                className="bg-[#4663AC] hover:bg-blue-950 text-white px-16 py-2 rounded-full cursor-pointer transition-all duration-300 mt-4"
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
              >
                <a href={url}> Rejoindre</a>
              </button>
            </div>
          </div>
          {/* left side */}
          <>
            <motion.img
              initial={{ x: 0, y: 0 }}
              animate={isButtonHovering || isHovering ? { x: 40, y: -5 } : { x: 0, y: 0 }}
              transition={{
                duration: 0.5,
                ease: EASING.easeInOut,
                delay: 0.5,
              }}
              className="absolute top-0 w-40 left-80 float"
              loading="lazy"
              src={polygon1}
              alt="polygon"
              onMouseEnter={() => setIsButtonHovering(true)}
              onMouseLeave={() => setIsButtonHovering(false)}
            />

            <motion.img
              initial={{ x: 0, y: 0 }}
              animate={isButtonHovering || isHovering ? { x: -20, y: -40 } : { x: 0, y: 0 }}
              transition={{
                duration: 0.5,
                ease: EASING.easeInOut,

                delay: 0.5,
              }}
              className="w-24 absolute top-16 left-[12.5rem]"
              loading="lazy"
              src={polygon2}
              alt="polygon"
              onMouseEnter={() => setIsButtonHovering(true)}
              onMouseLeave={() => setIsButtonHovering(false)}
            />
            <motion.img
              initial={{ x: 0, y: 0 }}
              animate={isButtonHovering || isHovering ? { x: 0, y: 25 } : { x: 0, y: 0 }}
              transition={{
                duration: 0.5,
                ease: EASING.easeInOut,

                delay: 0.5,
              }}
              className="w-[8.125rem] absolute top-36 left-64"
              loading="lazy"
              src={polygon3}
              alt="polygon"
              onMouseEnter={() => setIsButtonHovering(true)}
              onMouseLeave={() => setIsButtonHovering(false)}
            />
            <motion.img
              initial={{ x: 0, y: 0 }}
              animate={isButtonHovering || isHovering ? { x: -20, y: -40 } : { x: 0, y: 0 }}
              transition={{
                duration: 0.5,
                ease: EASING.easeInOut,

                delay: 0.5,
              }}
              className="w-[13.75rem] absolute top-32 left-8"
              loading="lazy"
              src={polygon4}
              alt="polygon"
              onMouseEnter={() => setIsButtonHovering(true)}
              onMouseLeave={() => setIsButtonHovering(false)}
            />
            <motion.img
              initial={{ x: 0, y: 0 }}
              animate={isButtonHovering || isHovering ? { x: 0, y: 25 } : { x: 0, y: 0 }}
              transition={{
                duration: 0.5,
                ease: EASING.easeInOut,

                delay: 0.5,
              }}
              className="w-32 absolute top-[21rem] left-40"
              loading="lazy"
              src={polygon5}
              alt="polygon"
              onMouseEnter={() => setIsButtonHovering(true)}
              onMouseLeave={() => setIsButtonHovering(false)}
            />
            <motion.img
              initial={{ x: 0, y: 0 }}
              animate={isButtonHovering || isHovering ? { x: -40, y: 10 } : { x: 0, y: 0 }}
              transition={{
                duration: 0.5,
                ease: EASING.easeInOut,

                delay: 0.5,
              }}
              className="w-[7.5rem] absolute top-[22.5rem] left-9"
              loading="lazy"
              src={polygon6}
              alt="polygon"
              onMouseEnter={() => setIsButtonHovering(true)}
              onMouseLeave={() => setIsButtonHovering(false)}
            />
            <motion.img
              initial={{ x: 0, y: 0 }}
              animate={isButtonHovering || isHovering ? { x: -40, y: 10 } : { x: 0, y: 0 }}
              transition={{
                duration: 0.5,
                ease: EASING.easeInOut,

                delay: 0.5,
              }}
              className="w-32 absolute top-[28.5rem] left-[6.5rem]"
              loading="lazy"
              src={polygon7}
              alt="polygon"
              onMouseEnter={() => setIsButtonHovering(true)}
              onMouseLeave={() => setIsButtonHovering(false)}
            />
            <motion.img
              initial={{ x: 0, y: 0 }}
              animate={isButtonHovering || isHovering ? { x: 0, y: 30 } : { x: 0, y: 0 }}
              transition={{
                duration: 0.5,
                ease: EASING.easeInOut,

                delay: 0.5,
              }}
              className="w-44 absolute top-[27.4rem] left-[14.6rem]"
              loading="lazy"
              src={polygon8}
              alt="polygon"
              onMouseEnter={() => setIsButtonHovering(true)}
              onMouseLeave={() => setIsButtonHovering(false)}
            />
          </>
          {/* right side */}
          <>
            <motion.img
              initial={{ x: 0, y: 0 }}
              animate={isButtonHovering || isHovering ? { x: -40, y: -5 } : { x: 0, y: 0 }}
              transition={{
                duration: 0.5,
                ease: EASING.easeInOut,

                delay: 0.5,
              }}
              className="absolute top-0 w-40 right-80"
              loading="lazy"
              src={polygon9}
              alt="polygon"
              onMouseEnter={() => setIsButtonHovering(true)}
              onMouseLeave={() => setIsButtonHovering(false)}
            />
            <motion.img
              animate={isButtonHovering || isHovering ? { x: -20, y: -40 } : { x: 0, y: 0 }}
              transition={{
                duration: 0.5,
                ease: EASING.easeInOut,

                delay: 0.5,
              }}
              className="w-24 absolute top-16 right-[12.5rem]"
              loading="lazy"
              src={polygon10}
              alt="polygon"
              onMouseEnter={() => setIsButtonHovering(true)}
              onMouseLeave={() => setIsButtonHovering(false)}
            />
            <motion.img
              initial={{ x: 0, y: 0 }}
              animate={isButtonHovering || isHovering ? { x: 0, y: 25 } : { x: 0, y: 0 }}
              transition={{
                duration: 0.5,
                ease: EASING.easeInOut,

                delay: 0.5,
              }}
              className="w-[8.125rem] absolute top-36 right-64"
              loading="lazy"
              src={polygon11}
              alt="polygon"
              onMouseEnter={() => setIsButtonHovering(true)}
              onMouseLeave={() => setIsButtonHovering(false)}
            />
            <motion.img
              initial={{ x: 0, y: 0 }}
              animate={isButtonHovering || isHovering ? { x: 20, y: -40 } : { x: 0, y: 0 }}
              transition={{
                duration: 0.5,
                ease: EASING.easeInOut,

                delay: 0.5,
              }}
              className="w-[13.75rem] absolute top-32 right-8"
              loading="lazy"
              src={polygon12}
              alt="polygon"
              onMouseEnter={() => setIsButtonHovering(true)}
              onMouseLeave={() => setIsButtonHovering(false)}
            />
            <motion.img
              initial={{ x: 0, y: 0 }}
              animate={isButtonHovering || isHovering ? { x: -40, y: 0 } : { x: 0, y: 0 }}
              transition={{
                duration: 0.5,
                ease: EASING.easeInOut,

                delay: 0.5,
              }}
              className="w-32 absolute top-[21rem] right-40"
              loading="lazy"
              src={polygon13}
              alt="polygon"
              onMouseEnter={() => setIsButtonHovering(true)}
              onMouseLeave={() => setIsButtonHovering(false)}
            />
            <motion.img
              initial={{ x: 0, y: 0 }}
              animate={isButtonHovering || isHovering ? { x: -40, y: -10 } : { x: 0, y: 0 }}
              transition={{
                duration: 0.5,
                ease: EASING.easeInOut,

                delay: 0.5,
              }}
              className="w-[7.5rem] absolute top-[22.5rem] right-9"
              loading="lazy"
              src={polygon14}
              alt="polygon"
              onMouseEnter={() => setIsButtonHovering(true)}
              onMouseLeave={() => setIsButtonHovering(false)}
            />
            <motion.img
              initial={{ x: 0, y: 0 }}
              animate={isButtonHovering || isHovering ? { x: 20, y: 40 } : { x: 0, y: 0 }}
              transition={{
                duration: 0.5,
                ease: EASING.easeInOut,

                delay: 0.5,
              }}
              className="w-32 absolute top-[28.5rem] right-[6.5rem]"
              loading="lazy"
              src={polygon15}
              alt="polygon"
              onMouseEnter={() => setIsButtonHovering(true)}
              onMouseLeave={() => setIsButtonHovering(false)}
            />
            <motion.img
              initial={{ x: 0, y: 0 }}
              animate={isButtonHovering || isHovering ? { x: 0, y: 40 } : { x: 0, y: 0 }}
              transition={{
                duration: 0.5,
                ease: EASING.easeInOut,

                delay: 0.5,
              }}
              className="w-44 absolute top-[27.4rem] right-[14.6rem]"
              loading="lazy"
              src={polygon16}
              alt="polygon"
              onMouseEnter={() => setIsButtonHovering(true)}
              onMouseLeave={() => setIsButtonHovering(false)}
            />
          </>
        </div>
      )}
      {isMobile && (
        <div className="grid justify-items-center">
          <div className="flex space-x-5">
            <>
              <motion.img
                animate={isButtonHovering || isHovering ? { x: -40, y: -5 } : { x: 0, y: 0 }}
                transition={{
                  duration: 1,
                  ease: EASING.easeInOut,
                  repeatType: "reverse",
                  repeatDelay: 1.5,
                  delay: 0.5,
                }}
                className="h-28 w-28"
                loading="lazy"
                src={polygon1}
                alt="polygon"
                onMouseEnter={() => setIsButtonHovering(true)}
                onMouseLeave={() => setIsButtonHovering(false)}
              />
              <motion.img
                animate={isButtonHovering || isHovering ? { x: 40, y: -5 } : { x: 0, y: 0 }}
                transition={{
                  duration: 1,
                  ease: EASING.easeInOut,
                  repeatType: "reverse",
                  repeatDelay: 1.5,
                  delay: 0.5,
                }}
                className="h-28 w-28"
                loading="lazy"
                src={polygon2}
                alt="polygon"
                onMouseEnter={() => setIsButtonHovering(true)}
                onMouseLeave={() => setIsButtonHovering(false)}
              />
            </>
          </div>
          <div className="flex space-x-5">
            <motion.img
              animate={isButtonHovering || isHovering ? { x: -30, y: 10 } : { x: 0, y: 0 }}
              transition={{
                duration: 1,
                ease: EASING.easeInOut,
                repeatType: "reverse",
                repeatDelay: 1.5,
                delay: 0.5,
              }}
              className="h-28 w-28"
              loading="lazy"
              src={polygon3}
              alt="polygon"
              onMouseEnter={() => setIsButtonHovering(true)}
              onMouseLeave={() => setIsButtonHovering(false)}
            />
            <motion.img
              animate={isButtonHovering || isHovering ? { y: 10 } : { y: 0 }}
              transition={{
                duration: 1,
                ease: EASING.easeInOut,
                repeatType: "reverse",
                repeatDelay: 1.5,
                delay: 0.5,
              }}
              className="h-28 w-28"
              loading="lazy"
              src={polygon4}
              alt="polygon"
              onMouseEnter={() => setIsButtonHovering(true)}
              onMouseLeave={() => setIsButtonHovering(false)}
            />
            <motion.img
              animate={isButtonHovering || isHovering ? { x: 40, y: 10 } : { x: 0, y: 0 }}
              transition={{
                duration: 1,
                ease: EASING.easeInOut,
                repeatType: "reverse",
                repeatDelay: 1.5,
                delay: 0.5,
              }}
              className="h-28 w-28"
              loading="lazy"
              src={polygon5}
              alt="polygon"
              onMouseEnter={() => setIsButtonHovering(true)}
              onMouseLeave={() => setIsButtonHovering(false)}
            />
          </div>
          <div className="flex flex-col items-center text-center">
            {" "}
            <h3 className="text-[#4663AC] text-4xl font-semibold">Rejoignez Event to Bee</h3>
            <p className="text-[#6C6C6C] text-xl mt-2">Devenez Hôte et Proposez Votre Espace !</p>
            <button
              className="bg-[#4663AC] hover:bg-blue-950 text-white px-16 py-2 rounded-full cursor-pointer transition-all duration-300 mt-4  "
              onMouseEnter={() => setIsHovering(true)}
              onMouseLeave={() => setIsHovering(false)}
            >
              <a href="/add/location"> Rejoindre</a>
            </button>
          </div>
          <div className="mt-10">
            <div className="flex space-x-5">
              <>
                <motion.img
                  animate={isButtonHovering || isHovering ? { x: -40, y: -5 } : { x: 0, y: 0 }}
                  transition={{
                    duration: 1,
                    ease: EASING.easeInOut,
                    repeatType: "reverse",
                    repeatDelay: 1.5,
                    delay: 0.5,
                  }}
                  className="w-28"
                  loading="lazy"
                  src={polygon9}
                  alt="polygon"
                  onMouseEnter={() => setIsButtonHovering(true)}
                  onMouseLeave={() => setIsButtonHovering(false)}
                />
                <motion.img
                  animate={isButtonHovering || isHovering ? { x: 0, y: -40 } : { x: 0, y: 0 }}
                  transition={{
                    duration: 1,
                    ease: EASING.easeInOut,
                    repeatType: "reverse",
                    repeatDelay: 1.5,
                    delay: 0.5,
                  }}
                  className=" w-28"
                  loading="lazy"
                  src={polygon10}
                  alt="polygon"
                  onMouseEnter={() => setIsButtonHovering(true)}
                  onMouseLeave={() => setIsButtonHovering(false)}
                />
                <motion.img
                  animate={isButtonHovering || isHovering ? { x: 30, y: -10 } : { x: 0, y: 0 }}
                  transition={{
                    duration: 1,
                    ease: EASING.easeInOut,
                    repeatType: "reverse",
                    repeatDelay: 1.5,
                    delay: 0.5,
                  }}
                  className="w-28"
                  loading="lazy"
                  src={polygon11}
                  alt="polygon"
                  onMouseEnter={() => setIsButtonHovering(true)}
                  onMouseLeave={() => setIsButtonHovering(false)}
                />
              </>
            </div>
            <div className="flex justify-center space-x-5">
              <motion.img
                animate={isButtonHovering || isHovering ? { x: -40, y: 5 } : { y: 0 }}
                transition={{
                  duration: 1,
                  ease: EASING.easeInOut,
                  repeatType: "reverse",
                  repeatDelay: 1.5,
                  delay: 0.5,
                }}
                className="w-28"
                loading="lazy"
                src={polygon12}
                alt="polygon"
                onMouseEnter={() => setIsButtonHovering(true)}
                onMouseLeave={() => setIsButtonHovering(false)}
              />
              <motion.img
                animate={isButtonHovering || isHovering ? { x: 40, y: 5 } : { x: 0, y: 0 }}
                transition={{
                  duration: 1,
                  ease: EASING.easeInOut,
                  repeatType: "reverse",
                  repeatDelay: 1.5,
                  delay: 0.5,
                }}
                className=" w-28"
                loading="lazy"
                src={polygon13}
                alt="polygon"
                onMouseEnter={() => setIsButtonHovering(true)}
                onMouseLeave={() => setIsButtonHovering(false)}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Header2;
